import React from 'react'
import { Card, CardBody, CardHeader } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import WatchInterview from './WatchInterview'

function WatchInterviewComponent({ interviewData, onClose }) {
  return (
    <Card>
      <CardHeader className='d-flex align-items-center justify-content-between'>
        <div>
          <span className='title'>Interview Recording</span>
          {interviewData.candidate_name && (
            <small className='text-muted ml-2'>
              - {interviewData.candidate_name}
            </small>
          )}
        </div>
        <button className='btn btn-secondary' onClick={onClose}>
          <FontAwesomeIcon icon={faArrowLeft} className='mr-2' />
          Go Back
        </button>
      </CardHeader>
      <CardBody>
        <WatchInterview interviewData={interviewData} />
      </CardBody>
    </Card>
  )
}

export default WatchInterviewComponent
